import { useMemo } from "react";
import { useCountryList } from "src/ui/shared/hooks/country-list.hook";

export const useCountryOption = (countryCode: string | undefined) => {
    const { list: countryList } = useCountryList();
    const countryOption = useMemo(() => countryList?.find(i => i.code === countryCode), [countryList, countryCode]);
    return countryOption;
}